/* esm.sh - copy-to-clipboard@4.0.2 */
export * from "/*copy-to-clipboard@4.0.2/esnext/copy-to-clipboard.mjs";
export { default } from "/*copy-to-clipboard@4.0.2/esnext/copy-to-clipboard.mjs";
